import { z } from 'zod';

// Only `grants` is read from the legacy /profile payload — passthrough prevents
// throwing on the many unrelated fields the response carries.
export const OwnerProfileResponseSchema = z.object({ grants: z.array(z.number()).optional() }).passthrough();
